import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useLocations = () => {
  const urlStr = `${getApiUrl()}/admin/location`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useLocation = (locationId) => {
  const urlStr = `${getApiUrl()}/location/${locationId}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostLocation = () => {
  const postLocation = async (payload) => {
    try {
      const url = `${getApiUrl()}/admin/location`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postLocation;
};

export const usePutLocation = () => {
  const putLocation = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/admin/location/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putLocation;
};

export const useDeleteLocation = () => {
  const deleteRegion = async (id) => {
    try {
      const url = `${getApiUrl()}/admin/location/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return deleteRegion;
};
